import { render } from "./SelfServiceLogin.vue?vue&type=template&id=53886409&scoped=true"
import script from "./SelfServiceLogin.vue?vue&type=script&lang=js"
export * from "./SelfServiceLogin.vue?vue&type=script&lang=js"

import "./SelfServiceLogin.vue?vue&type=style&index=0&id=53886409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53886409"]])

export default __exports__